
import { Route } from '@/app/router'

const DeliverySheets = () => import('./index.vue')

const DeliverySheetsMeta = {
	sort: 13,
	displayInSidebar: true,
	displayName: 'delivery-sheet',
	icon: 'fal file-spreadsheet',
	activeIcon: 'fas file-spreadsheet'
}

const DeliverySheetsProps = ['page', 'perPage']

export default new Route('/delivery-sheets', DeliverySheets)
	.as('Dashboard:DeliverySheets')
	.meta(DeliverySheetsMeta)
	.props(DeliverySheetsProps)
	.permissions(['VIEW_OEM_DELIVERY_SHEET', 'OEM_ENABLED'])
